
import React from 'react';
import ReactDOM from 'react-dom';
import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';
import Fade from '../utils/Fade';



export default class ReInitAPPComponent extends React.Component {
	constructor(props, context) {
		super(props, context);
		//判断是否是管理员
		this.userInfos = window.userInfos;
		
		if (this.userInfos.userGroups.indexOf("admin") != -1 || this.userInfos.userGroups.indexOf("Admin") != -1) {
		  this.isAdmin = true;
		}
		else{
			this.isAdmin = false;
		}
    	this.state = {
			appList:this.props.appList
		};
	}
	componentDidMount(){
        return;
		$(this.radioContainer).find('input[type="radio"].minimal').iCheck({
			radioClass: 'iradio_minimal-blue'});
	}

	//关闭
	hideReInitAPP = () => {
		let $reactComponentContainer = $("#globalUserSetFormDiv");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		$("#globalUserSetFormDiv").empty().css("display", "none");
	}

	

	changeautoEnterList = () => {
	  var tag = $("#autoEnterListCheckBox").prop("checked");
	  window.userSettingEntry.autoEnterList = tag;
	  this.userSettingEntry.autoEnterList = tag;
	}

	

	btnsave_clickHandler = () =>{
		
		var command = Command.createService( "gongqi.erp.gotmodel.services.GOTService", "reInitSolution", "void");
		var selectedApp=$(this.radioContainer).find("input[type='radio']:checked").attr("data-serverId");
		command.appendArg(selectedApp);
		
		var remoteArg = {
			command: command,
			resultFunction: this.saveResultHandler,
			sync: false
		}
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	saveResultHandler = () =>{

		this.hideReInitAPP();
		window.location.reload();
	}

    getAppList()
    {
        let list = [];
        for(let i = 0;i<this.state.appList.length;i++)
        {
            let label = this.state.appList[i];
           
            list.push(<label style={{fontWeight:'200',margin:'0px',marginBottom:"5px",display:"flex",minHeight:'20px'}} key={i}>
                        <input style={{marginRight:'5px'}} type="radio" name="appSolutionsRadio" className="minimal" data-serverId={label}/>
                        <div style={{fontSize:'14px'}}>{label}</div>
                       </label>
            );
                /*<div draggable="true" style={{paddingLeft:'15px'}}>
                    <label><input style={{marginRight:'10px'}} type="radio" id="isShowBusyRemoteCheckBox" name="" value="on" />{label}&emsp;</label>
                </div>*/
        }
		if(list.length==0){

            list.push(<label style={{fontWeight:'200',margin:'0px',marginBottom:"5px",display:"flex",minHeight:'20px',justifyContent:'center'}} >
                        <div style={{fontSize:'16px'}}>当前环境暂无应用</div>
                       </label>
            );
		}
        return list;
    }
	

	render(){
		let btnSty={display:'flex',flexDirection:'horizontal',flexGrow:0,paddingTop:'10px',paddingBottom:'10px'};
		if(this.state.appList && this.state.appList.length ==0){
			btnSty.display='none';
		}
		return(

			<div  style={{alignSelf:"center",borderRadius:"2px",backgroundColor:'white',minWidth:'200px',display:'flex',flexDirection:'column',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)'}}>
		      <div className="modal-header" style={{background:"#ffffff",padding:"10px",position:"relative",paddingTop:"15px",paddingBottom:"15px",background:"#F8F8F8"}}>
				<div className="modal-close" onClick={this.hideReInitAPP.bind(this)}></div>
		        <h5 className="modal-title">选择应用</h5>
		      </div>
              
			  <div ref={node=>this.radioContainer = node} style={{display:'flex',flexDirection:'column',flexGrow:100,padding:'5px',maxHeight:'700px',overflowY:'auto'}}>

                {this.getAppList()}
		       
				<div style={btnSty}>
					<div style={{flexGrow:100}}></div>
					<button type="button" className="btn btn-info" style={{height:'25px',marginTop:'5px'}} onClick={this.btnsave_clickHandler}>初始化选中应用</button>
				</div>
		      </div>


		    </div>

		)
	}

}


// WEBPACK FOOTER //
// ./src/components/ReInitAPPComponent.js